// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-blue: #003f64;
  --color-dark-blue: #1a2733;
  --color-creme: #fef4e2;
  --color-marone: #d8a87d;
  --color-little-extra: #3d40e3;
  --color-white: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
}

.team-section {
  padding: 4rem 0;
  background-color: var(--color-creme);
  text-align: center;
  color: var(--color-dark-blue);
}

.team-grid {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.team-member {
  width: 200px;
  padding: 2rem;
  background-color: var(--color-dark-blue);
  border-radius: 12px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  overflow: hidden;
  position: relative;
}

.team-member:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.team-member img {
  max-width: 100px;
  border-radius: 50%;
  margin-bottom: 1rem;
}

.team-section h2 {
  font-size: 3rem;
  margin-bottom: 2rem;
  color: var(--color-dark-blue);
}

.team-section h3 {
  font-size: 1.7rem;
  margin-bottom: 0.5rem;
  color: var(--color-marone);
}

.team-section p {
  color: var(--color-creme);
}

/* Ein kleiner Hover-Effekt für die Bilder der Teammitglieder. */
.team-member img:hover {
  border: 3px solid var(--color-little-extra);
}
`, "",{"version":3,"sources":["webpack://./src/container/Team/team.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,mEAAmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,2CAA2C;AAC7C","sourcesContent":[":root {\r\n  --color-blue: #003f64;\r\n  --color-dark-blue: #1a2733;\r\n  --color-creme: #fef4e2;\r\n  --color-marone: #d8a87d;\r\n  --color-little-extra: #3d40e3;\r\n  --color-white: #ffffff;\r\n}\r\n\r\nbody {\r\n  font-family: \"Poppins\", sans-serif;\r\n}\r\n\r\n.team-section {\r\n  padding: 4rem 0;\r\n  background-color: var(--color-creme);\r\n  text-align: center;\r\n  color: var(--color-dark-blue);\r\n}\r\n\r\n.team-grid {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.team-member {\r\n  width: 200px;\r\n  padding: 2rem;\r\n  background-color: var(--color-dark-blue);\r\n  border-radius: 12px;\r\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.team-member:hover {\r\n  transform: scale(1.05);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.team-member img {\r\n  max-width: 100px;\r\n  border-radius: 50%;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.team-section h2 {\r\n  font-size: 3rem;\r\n  margin-bottom: 2rem;\r\n  color: var(--color-dark-blue);\r\n}\r\n\r\n.team-section h3 {\r\n  font-size: 1.7rem;\r\n  margin-bottom: 0.5rem;\r\n  color: var(--color-marone);\r\n}\r\n\r\n.team-section p {\r\n  color: var(--color-creme);\r\n}\r\n\r\n/* Ein kleiner Hover-Effekt für die Bilder der Teammitglieder. */\r\n.team-member img:hover {\r\n  border: 3px solid var(--color-little-extra);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
